export const OPEN_EMPLOYMENT_INELIGIBILITY_REASON = "Has open employment";

export type LifeMemberEligibilityOption = {
  code: string;
  label: string;
  eligible: boolean;
  ineligibilityReasons: string[];
  requiresAttestation?: boolean;
  attestationCopyParagraphs?: string[];
  attestationAcknowledgementLabel?: string | null;
};

export type LifeMemberEligibility = {
  hasOpenEmployment: boolean;
  options: LifeMemberEligibilityOption[];
};

/** Codes that qualify except for open employment (shown on the Request button while employed). */
export function requestableNonActiveClassificationCodes(
  eligibility: LifeMemberEligibility | null | undefined
): string[] {
  if (!eligibility?.options?.length) return [];

  return eligibility.options
    .filter((option) => {
      if (option.eligible) return true;
      const reasons = option.ineligibilityReasons ?? [];
      return reasons.length > 0 && reasons.every((reason) => reason === OPEN_EMPLOYMENT_INELIGIBILITY_REASON);
    })
    .map((option) => option.code);
}

export function nonActiveClassificationRequestButtonLabel(codes: string[]): string {
  if (!codes.length) return "Request";
  return `Request ${codes.join(", ")}`;
}

export function eligibleNonActiveClassificationOptions(
  eligibility: LifeMemberEligibility | null | undefined
): LifeMemberEligibilityOption[] {
  return (eligibility?.options ?? []).filter((option) => option.eligible);
}
